import React from 'react';
import { Message, Icon, Button, Form, TextArea, Segment } from 'semantic-ui-react';

const ValidCoverageAndRatingError = props => {

    if (props.dueDatePassed) {
        return (
            <Segment>
            <Message negative icon>
                <Icon name='exclamation triangle' />
                <p style={{ marginRight: '15px' }}>{props.errorMessage}</p>


            </Message>
            <Form as='div'>
                    <Form.Field>
                        <label>Explanation</label>
                        <TextArea
                            autoHeight
                            placeholder='Enter your explanation here'
                            rows={3}
                            value={props.dueDateExplanation}
                            onChange={props.onDueDateExplanationChange}
                            disabled={props.readOnly}
                        />
                    </Form.Field>
                </Form>
                <Button
                    color='green'
                    onClick={() => props.onDueDateReviewSubmit('REVIEW', 'LATE')}
                    loading={props.saving}
                    disabled={props.saving}
                >
                        Submit for review
                </Button>
            </Segment>
        );
    } else {
        return (
            <Message negative icon>
                <Icon name='exclamation triangle' />
                <p style={{ marginRight: '15px' }}>{props.errorMessage}</p>
                <Button color='red' as='a' href={props.contactBureauEmail}>Please contact the Bureau.</Button>
            </Message>
        );
    }
}

export default ValidCoverageAndRatingError;